import UploadAttachment from './UploadAttachment';

export default UploadAttachment;
